import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'; // Import Container, Row, and Col from the correct source
import { Link } from 'react-router-dom';
import Academicleft from '../Academic/Academicleft'; // You should import 'Academicleft' if it's a local component

function StatementExpenELe() {
    return (
        <>
            <section className="project-detail">
                <Container>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h3>Statement of Expenditure</h3>
                            </div>
                        </div>
                    </div>
                  
                  <Row>
                        <Col md={4} className='c-left custom-padding-color mb-4'>
                            <Academicleft activeIndex={11} />
                        </Col>
                        <Col md={8} className='c-right'>
                        <Row>
                            <div className="col-lg-4 col-md-4">
                                <div className="services-box">
                                    <h3>B.Tech</h3>
                                    <div className="services-content2">
                                        <Link to="https://files.iittp.ac.in/pdfs/soe/2023/BTech.pdf" className="c-link">Click here</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="services-box">
                                    <h3>M.Tech</h3>
                                    <div className="services-content2">
                                        <Link to="https://files.iittp.ac.in/pdfs/soe/2023/Mtech.pdf" className="c-link">Click here</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="services-box">
                                    <h3>M.S (Research)</h3>
                                    <div className="services-content2">
                                        <Link to="https://files.iittp.ac.in/pdfs/soe/2023/MS(Research).pdf" className="c-link">Click here</Link>
                                    </div>
                                </div>
                            </div>
                     
                        </Row>

                            <Row className='mt-5'>
                                <div className="col-lg-4 col-md-4 ">
                                    <div className="services-box">
                                        <h3>Ph.D.</h3>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/soe/2023/PhD.pdf" className="c-link">Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box">
                                        <h3>M.Sc</h3>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/soe/2023/MSc.pdf" className="c-link">Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box">
                                        <h4>Master of Public Policy (MPP)</h4>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/soe/2023/MPP.pdf" className="c-link">Click here</Link>
                                        </div>
                                    </div>
                                </div>
                            </Row>
               
                        </Col>
                    </Row>
                </Container> {/* container */}
            </section>
        </>
    )
}

export default StatementExpenELe;
